import { getValidToken } from "utils/getValidToken";

export async function postData(url, payload) {
  const token = await getValidToken();

  const response = await fetch(url, {
    method: "POST",

    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,

      // 'X-API-Key': 'T3l3trelSeXAnLtxHoPTAUK7W1vqblC1zGbHnk1IJzI'
    },
    body: JSON.stringify(payload),
  });

  const text = await response.text(); // read once
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${text}`);
  }

  // If backend sometimes returns empty body on success
  return text ? JSON.parse(text) : null;
}